export default __webpack_public_path__ + "/dist/images/error-icon.02d0927c65e22004f49bcc03c94f41a6.svg";